import { makeStyle } from '../../../../utils';
import { blackHigh, blackMedium, subTitle2 } from '../../../../resources/styles';


const styles = {};

styles['revenue_parent'] = makeStyle({width:'100%'});

styles['heading'] = makeStyle([subTitle2, blackHigh,{margin:'5px 7px'}]);

styles['city_input'] = makeStyle({
    borderRadius: '2px',
    border: 'solid 1px rgba(0, 0, 0, 0.08)',
    padding: '10px 0px 10px 16px',
    width: '-webkit-fill-available',
    marginBottom:'8px',
    ...blackHigh
})

export default styles;
